import { decodeServer, encode, type ClientMessage, type ServerMessage } from "@dyson/shared";

/** Thin typed wrapper over a browser WebSocket. */
export class Connection {
  private ws?: WebSocket;

  onOpen: () => void = () => {};
  onClose: (reason: string) => void = () => {};
  onMessage: (msg: ServerMessage) => void = () => {};

  constructor(private readonly url: string) {}

  connect(): void {
    this.close();
    const ws = new WebSocket(this.url);
    ws.binaryType = "arraybuffer";
    this.ws = ws;
    ws.addEventListener("open", () => this.onOpen());
    ws.addEventListener("close", (e) => this.onClose(e.reason || `code ${e.code}`));
    ws.addEventListener("error", () => this.onClose("connection error"));
    ws.addEventListener("message", (e) => {
      if (!(e.data instanceof ArrayBuffer)) return;
      const msg = decodeServer(new Uint8Array(e.data));
      if (msg) this.onMessage(msg);
    });
  }

  close(): void {
    if (this.ws) {
      this.ws.onclose = null;
      this.ws.close();
      this.ws = undefined;
    }
  }

  get connected(): boolean {
    return this.ws?.readyState === WebSocket.OPEN;
  }

  send(msg: ClientMessage): void {
    if (this.connected) this.ws!.send(encode(msg));
  }
}
